import React, { useEffect, useState } from 'react'
import Switch from '@mui/material/Switch'
import { FormControlLabel } from '@mui/material'

interface Props {
  name?: string
  value?: boolean
  label?: string
  disabled?: boolean
  onChange?: (checked: boolean) => void
}

const SwitchComponent: React.FC<Props> = (props) => {
  const [value, setValue] = useState<boolean>(props.value || false)
  const disabled = props.disabled || false
  useEffect(() => {
    setValue(props.value || false)
  }, [props.value])

  return (
    <FormControlLabel
      control={
        <Switch
          {...props}
          disabled={disabled}
          checked={value}
          onChange={(event) => props.onChange && props.onChange(event.target.checked)}
        />
      } label={props.label || ''}
    />
  )
}

export default SwitchComponent
